import { TenantAvailabilityState } from '@shared/service-proxies/service-proxies';

export class AppTenantAvailabilityState {
    static Available: TenantAvailabilityState = TenantAvailabilityState._1;
    static InActive: TenantAvailabilityState = TenantAvailabilityState._2;
    static NotFound: TenantAvailabilityState = TenantAvailabilityState._3;
}
